<template>
  <div class="questionnaire">
    <div class="questionnaireBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearSearch">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="filter">
        <el-col :span="8">
          <span class="label">问卷</span>
          <el-input
            v-model="tableConfig.name"
            placeholder="检查ID或名称"
            style="width: auto"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">问卷类型</span>
          <el-select v-model="tableConfig.surveyClassID" placeholder="">
            <el-option
              v-for="(item, index) in categoryList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">状态</span>
          <el-select v-model="tableConfig.enable" placeholder="">
            <el-option
              v-for="(item, index) in statusList"
              :key="index"
              :label="item.name"
              :value="item.statusNo"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row>
        <el-col :span="22">数据列表</el-col>
        <el-col :span="2">
          <el-button
            plain
            round
            icon="el-icon-plus"
            size="small"
            style="color: #67C23A"
            @click="openCreate()"
          >
            新 建
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          sortable
          type="index"
          label="序号"
          width="100"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="name"
          label="问卷名称"
        ></el-table-column>
        <el-table-column
          sortable
          prop="surveyClassName"
          label="问卷类型"
          width="150"
        ></el-table-column>
        <el-table-column
          sortable
          prop="enable"
          label="状态"
          width="150"
          :formatter="enableFormat"
        >
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="color: #606266" icon="el-icon-edit" size="mini" @click="openEdit(scope.row.id)"
            >编辑</el-button>
            <el-button type="text" style="color: #606266" icon="el-icon-delete" size="mini" @click="openDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
  </div>
</template>
<script>
import md5 from "md5";

export default {
  name: "Questionnaire",
  data() {
    return {
      name: '',
      questionnaireCategory: '',
      status: '',
      categoryList: [
      ],
      statusList: [
        {
          name: '启用',
          statusNo: true
        },
        {
          name: '不启用',
          statusNo: false
        },
      ],
      tableData: [
        {
          surveyClassID: 1,
          surveyClassName: 1,
          name: '',
          enable: null,
        },
      ], // 列表
      total: 10, // 总数量
      tableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
        surveyClassID: null, //分类
        name: "", //题目
        enable: null, //检查项
      },
      tableLoading: false
    }
  },
  mounted() {
    this.getData()
    this.surveyClass()
  },
  methods: {
    searchData () {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      let res = await axios.post(oprReqUrl+"survey/search", this.tableConfig);
      res = res.data
      if (res.code === 200) {
        this.tableData = res.data.list || [];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    async clearSearch(){
      this.tableConfig.name = "";
      this.tableConfig.surveyClassID = null;
      this.tableConfig.enable = null;
    },
    async surveyClass(){ //问卷类型
      let res = await axios.post(oprReqUrl+"surveyclass/search", {});
      res = res.data
      if (res.code === 200) {
        this.categoryList = res.data.list || [];
      }
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    openCreate() {
      this.$router.push({ path: '/opr/questionnaireEdit' });
    },
    openEdit(id) {
      console.log('id', id);
      this.$router.push({ path: '/opr/questionnaireEdit', query: { id } });
    },
    async openDelete(id) {
      let res = await axios.post(oprReqUrl+"survey/delete", { id });
      if (res.data.code === 200) {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        await this.getData();
      }
    },
    enableFormat(row){
      switch (row.enable) {
        case true:
          return "启用"
          break;
        case false:
          return "不启用"
          break;
        default:
          return "未知"
          break;
      }
    }
  }
};
</script>
<style lang="sass" scoped>
.questionnaire
  min-width: 1050px
  .questionnaireBox
    padding: 20px
    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px
    .filter
      margin-top: 30px
    .label
      font-size: 14px
      color: #606266
    .table-container
      margin-top: 20px
    footer
      padding-top: 20px
      text-align: right
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/Check/questionnaire.vue